import { For } from "solid-js";
import { SIGNAL_NAVIGATION_GROUP } from "../../enums/navigation";
import type { SignalModule } from "../../enums/scan";
import { socialEnabled } from "../../store/demo";
import {
  primarySignalModule,
  SIGNAL_DESTINATIONS,
  signalDestinationHref,
  signalNavigationModules,
} from "./signalModules";

export function ScanPrimaryNavigation(props: {
  websiteId: string;
  activeModule: SignalModule | "none";
}) {
  return (
    <nav class="signal-module-nav" aria-label="Faro Signal modules">
      <For
        each={signalNavigationModules(
          SIGNAL_NAVIGATION_GROUP.PRIMARY,
          socialEnabled(),
        )}
      >
        {(module) => (
          <a
            class="signal-module-link"
            classList={{
              "is-active": primarySignalModule(props.activeModule) === module,
            }}
            href={signalDestinationHref(props.websiteId, module)}
            aria-current={
              primarySignalModule(props.activeModule) === module
                ? "page"
                : undefined
            }
          >
            {SIGNAL_DESTINATIONS[module].label}
          </a>
        )}
      </For>
    </nav>
  );
}
